import {
  CalendarPcvVisitEvent,
  PcvVisitList,
} from '../models/unitPcvVisit';
import {
  VISIT_PRE_SALE_STATUS_BADGE_COLOR,
  VISIT_PRE_SALE_STATUS_NAMES,
  VisitPreSaleState,
} from '../../../constants/visitsConstants';

export const pickPcvCalendarEventColor = (status: string): string => {
  switch (status) {
    case VisitPreSaleState.DELETED:
      return 'bg-red text-white';
    case VisitPreSaleState.DONE:
      return 'bg-success text-white';
    case VisitPreSaleState.RESCHEDULED:
      return 'bg-info text-white';
    case VisitPreSaleState.PENDING_APPROVAL:
      return 'bg-warning text-white';
    default:
      return 'bg-secondary';
  }
};

export const buildCalendarPcvVisitEvent = (
  visit: PcvVisitList,
  dateTime: { year: number; month: number; day: number; hours: number; minutes: number },
): CalendarPcvVisitEvent => {
  const { year, month, day, hours, minutes } = dateTime;
  const visitorName = visit.landlordInfo ? visit.landlordInfo.name : 'NA';

  return {
    id: visit.id,
    title: `Asesoría ${visitorName}`,
    start: new Date(year, month - 1, day, hours, minutes),
    allDay: false,
    className: pickPcvCalendarEventColor(visit.status),
    landlordInfo: visit.landlordInfo,
    status: visit.status,
    proper_id: visit.proper_id ?? null,
  };
};

export const buildCalendarPcvVisitData = (
  visits: PcvVisitList[],
): CalendarPcvVisitEvent[] =>
  visits.map((v) => buildCalendarPcvVisitEvent(v, v.visitDateTime));

export const getPcvVisitStatusLabel = (status: string): string =>
  VISIT_PRE_SALE_STATUS_NAMES.hasOwnProperty(status)
    ? VISIT_PRE_SALE_STATUS_NAMES[status]
    : 'NA';

export const getPcvVisitBadgeColor = (status: string): string =>
  VISIT_PRE_SALE_STATUS_BADGE_COLOR.hasOwnProperty(status)
    ? VISIT_PRE_SALE_STATUS_BADGE_COLOR[status]
    : 'default';
